import { Role, RoleLevel, RoleTypeUrlParameters } from '@infuse/iam/role/type';

export function getRoleLevel(role: { organisationId?: string; tenantId?: string }): RoleLevel {
  if (role.organisationId) {
    return 'organisation';
  } else if (role.tenantId) {
    return 'tenant';
  }
  return 'domain';
}

export function getScopeText(
  role: { organisationId?: string; tenantId?: string; shared?: boolean },
  t: (key: string) => string
): string {
  const level = getRoleLevel(role);
  const isShared = role.shared ?? false;

  if (level === 'domain') {
    return isShared ? t('iam.roles.scopeOptions.domainToTenantToOrg') : t('iam.roles.scopeOptions.domainOnly');
  } else if (level === 'tenant') {
    return isShared ? t('iam.roles.scopeOptions.tenantToOrg') : t('iam.roles.scopeOptions.tenantOnly');
  } else {
    // organisation level
    return t('iam.roles.scopeOptions.orgOnly');
  }
}

export function getScopeTooltip(
  role: { tenantId?: string; organisationId?: string; shared?: boolean },
  t: (key: string) => string
): string {
  const level = getRoleLevel(role);
  const isShared = role.shared ?? false;

  if (level === 'domain') {
    return isShared
      ? t('iam.roles.scopeOptions.tooltip.domainToTenantToOrg')
      : t('iam.roles.scopeOptions.tooltip.domainOnly');
  } else if (level === 'tenant') {
    return isShared ? t('iam.roles.scopeOptions.tooltip.tenantToOrg') : t('iam.roles.scopeOptions.tooltip.tenantOnly');
  } else {
    // organisation level
    return t('iam.roles.scopeOptions.tooltip.orgOnly');
  }
}

export function isRoleSharedToThisLevel(role: Role, currentLevel: RoleLevel = 'domain'): boolean {
  const roleLevel = getRoleLevel(role);
  return roleLevel !== currentLevel && role.shared;
}

export function getRankingIcon(ranking: number): [string, string] {
  if (ranking >= 5) {
    return ['fad', 'signal-weak'];
  }
  if (ranking === 4) {
    return ['fad', 'signal-fair'];
  }
  if (ranking === 3) {
    return ['fad', 'signal-good'];
  }
  if (ranking === 2) {
    return ['fad', 'signal-strong'];
  }
  return ['fad', 'signal-perfect'];
}

export function getRoleUrlParameters(role: Role): RoleTypeUrlParameters | undefined {
  const level = getRoleLevel(role);

  if (level === 'domain') {
    return;
  }

  return {
    levelId: level === 'tenant' ? role.tenantId : role.organisationId,
    level: level,
  };
}
